import { Component } from '@angular/core';
import { EditQueryComponent } from 'components/query/edit-query.component';
import { CredentialType } from 'enums/CredentialType';
import { QueryModel } from 'models/generated/Entities.GormCrm.Query';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';
import { QueryService } from 'services/query.service';

@Component({
	selector: 'listquery',
	templateUrl: './list-query.component.html',
	imports: [Layout, ListView, TranslatePipe]
})
@ComponentUrl('list-queries')
@CredentialRequired(CredentialType.QueriesAccessFull)
export class ListQueryComponent {
	queries: QueryModel[] = [];
	selectedQuery: QueryModel | null = null;

	constructor(private readonly navigation: NavigationService,
		private readonly queryService: QueryService,
		private readonly notificationService: NotificationService) {
		this.updateQueryList();
	}

	updateQueryList() {
		this.queryService.getQueries().then(queries => {
			this.queries = queries;
			if (this.selectedQuery && !queries.find(query => query.id === this.selectedQuery!.id)) {
				this.selectedQuery = null;
			}
		});
	}

	displayQuery(query: QueryModel) {
		this.navigation.openRelativeView(this, 'list-query', EditQueryComponent).then(view => {
			view.queryId = query.id!;
		});
		this.selectedQuery = query;
	}

	deleteQuery(query: QueryModel) {
		if (query.system != null) {
			this.notificationService.error('query.system-query-delete', query.name);
			return;
		}
		this.notificationService.confirm('query.prompt-for-delete', { 'query.name': query.name }).subscribe(result => {
			if (result)
				this.queryService.deleteQuery(query.id!).then(() => this.updateQueryList());
		});
	}

	createQuery() {
		this.navigation.openRelativeView(this, 'list-query', EditQueryComponent).then(view => view.queryId = undefined);
	}
}
